import { render, staticRenderFns } from "./RightTriangleViz.vue?vue&type=template&id=1517bda1&scoped=true"
import script from "./RightTriangleViz.vue?vue&type=script&lang=js"
export * from "./RightTriangleViz.vue?vue&type=script&lang=js"
import style0 from "./RightTriangleViz.vue?vue&type=style&index=0&id=1517bda1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517bda1",
  null
  
)

export default component.exports